module.exports = __webpack_public_path__ + "img/s7.942dd3bb.jpg";